'use strict';

export default class FeaturesManager {
  constructor() {
    if (FeaturesManager.instance) {
      return FeaturesManager.instance;
    }

    FeaturesManager.instance = this;
    this.supervisorFeatures = {
      enable: !process.env.DISABLE_SUPERVISOR_FEATURES || process.env.DISABLE_SUPERVISOR_FEATURES === false
    };

    return FeaturesManager.instance;
  }

  install(Vue) {
    Vue.prototype.$featuresManager = FeaturesManager.instance;
  }
}
